import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";
import { useContent } from "../../context/ContentContext";
import { getIcon } from "../../lib/icons";
import { slugify } from "../../data/details";

export default function Services() {
  const ref = useReveal();
  const { content } = useContent();
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="homi-section-tag text-homi-goldDark text-sm">What We Offer</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">
            Expert Trades Under One Roof
          </h2>
        </div>
        <div ref={ref} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {content.services.map((s, i) => {
            const Icon = getIcon(s.icon);
            return (
              <div key={s.title} className="reveal group bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300" style={{ transitionDelay: `${i * 60}ms` }}>
                <div className="w-16 h-16 rounded-2xl bg-homi-gold/15 flex items-center justify-center mb-6 transition-transform group-hover:scale-110">
                  <Icon className="w-8 h-8 text-homi-goldDark" />
                </div>
                <h3 className="font-heading font-bold text-xl text-homi-black mb-3">{s.title}</h3>
                <p className="text-homi-body leading-relaxed mb-5">{s.desc}</p>
                <Link to={`/homi/services/${slugify(s.title)}`} className="inline-flex items-center gap-2 font-heading font-bold text-homi-goldDark group-hover:gap-3 transition-all">
                  Learn More <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
